import React, { useContext } from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'

//Components
import Modal from 'components/Modal'
import Checkbox from 'components/Checkbox'

//Context
import { ThemeContext } from 'context/theme-context'

export interface Props {
  show: boolean
  onHide: () => void
}

const SettingsModal = ({show, onHide}:Props) => {
  const { invertColors, toggleInvertColors } = useContext(ThemeContext)
  const { t } = useTranslation()

  const title = t('helpcenter-gui-icu.settings.modal.title')

  return (
    <>
      <Modal show={show} title={title} onHide={onHide}>
        <Checkbox id="invert-color-checkbox" checked={invertColors} onChange={toggleInvertColors} label={t('helpcenter-gui-icu.settings.field.invert_colors.label')}/>
      </Modal>
    </>
  )
}

export default SettingsModal